import { render, staticRenderFns } from "./message-thinking.vue?vue&type=template&id=a21e3adc&scoped=true"
import script from "./message-thinking.vue?vue&type=script&lang=ts"
export * from "./message-thinking.vue?vue&type=script&lang=ts"
import style0 from "./message-thinking.vue?vue&type=style&index=0&id=a21e3adc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a21e3adc",
  null
  
)

export default component.exports